<template>
  <section class="oldProduct">
    <div class="box-card">
      <div class="card-header clearfix">旧机估价</div>
      <div class="box-content" v-if="assess.goodsId">
        <div class="contentLeft">
          <div
            class="image"
            :style="'background:url('+assess.goodsImg+') no-repeat;background-size:100%;'"
          ></div>
          <div class="name">{{assess.goodsName}}</div>
          <div class="contentBtn">
            <a href="javascript:;" @click="clickReturnAttr">重新评估</a>
          </div>
        </div>
        <div class="contentRight">
          <div class="price">
            评估报价
            <span>
              <em>¥</em>
              {{assess.assessAmount}}
            </span>
          </div>
          <div class="attrs">
            <span v-for="item in assess.assessUserAttr.split(',')" :key="item">{{item}}</span>
          </div>
        </div>
        <van-icon name="delete" class="icon-delete" @click="clearProduct()"/>
      </div>
      <div class="box-content" v-else>
        <div class="item" @click="clickReturnCate">
          <p>
            添加您的旧机享受超额优惠
            <van-tag color="#fc5b74" plain style="margin-left:0.05rem">必选项</van-tag>
          </p>
          <van-icon name="arrow" class="item-right"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["assess"],
  inject: ["reload"],
  methods: {
    clickReturnAttr() {
      this.$router.push({ path: "/mobile/oldproduct/" + this.assess.goodsId });
    },
    clickReturnCate() {
      this.$router.push({ path: "/mobile/category" });
    },
    clearProduct(){
      localStorage.assess = "";
      // this.$store.commit('assess/setAssessData', {data:{assessAmount:0}});
      // this.reload();
      window.location.reload()
    }
  }
};
</script>

<style scoped>
.oldProduct {
  margin: 0 auto;
  background: #fff;
}
.box-content {
  display: flex;
  padding: 0.12rem 0.16rem;
  position: relative;
}
.van-icon-delete{
  position: absolute;
  right:0.1rem;
  top: 0.1rem;
  font-size: 0.2rem;
}
.box-content .item {
  position: relative;
  padding: 0 0 0 0.3rem;
  width: 100%;
}
.box-content .item p{margin-left:0.11rem;color: #333;}
.box-content .item-right {
  position: absolute;
  right: 0rem;
  top: 0rem;
  font-size: 0.18rem;
}
.box-content .item::before {
  display: inline-block;
  content: "";
  width: 0.26rem;
  height: 0.26rem;
  background: url(../../../assets/image/content_phone.png) no-repeat;
  background-size: 100%;
  position: absolute;
  top: -0.05rem;
  left: 0;
}
.card-header {
  line-height: 0.48rem;
  height: 0.48rem;
  padding: 0 0.15rem;
  border-bottom: solid #efefef 1px;
}
.contentLeft {
  text-align: center;
  width: 0.6rem;
}
.contentLeft .image {
  width: 0.6rem;
  height: 0.6rem;
  background: url(https://image.suhuishou.com/attached/image/20181120/20181120171959_48005.jpg)
    center center no-repeat;
  background-size: 100%;
  display: inline-block;
}
.contentLeft .name {
  margin: 0.1rem 0;
  font-size: 0.12rem;
}
.contentLeft .contentBtn a {
  display: inline-block;
  font-size: 0.14rem;
  font-weight: 400;
  color: rgba(249, 65, 93, 1);
  line-height: 0.3rem;
}
.contentRight {
  width: 2.8rem;
  margin-left: 0.23rem;
  font-size: 0.12rem;
}
.contentRight .price {font-size: 0.13rem;}
.contentRight .price span {
  margin-left: 0.05rem;
  font-size: 0.15rem;
  color: #e60012;
}
.contentRight .price span em {
  font-style: normal;
  font-size: 0.1rem;
}
.contentRight .attrs {
  margin-top: 0rem;
}
.contentRight .attrs span {
  display: inline-block;
  padding: 0.04rem 0.07rem;
  background: rgba(243, 243, 243, 1);
  border-radius: 0.08rem;
  margin:0.09rem 0.07rem 0 0;
  font-size: 0.12rem;
  color: #999999;
}
</style>
